import { merge, delay } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { RouterAction } from '@cbridge-packages/routing';
import { generateSyntheticSymbolRoute } from '@cbridge-packages/routing-client-admin';
import { SymbolSyntheticAction } from '@cbridge-packages/symbol-synthetic';

export const toggleViewSyntheticSymbolSidebarEpic: IEpic = (action$) => merge(
  action$.pipe(
    isTypeOfAndGetPayload(SymbolSyntheticAction.create.done),
    delay(100),
    map(({ result }) => {
      return RouterAction.replace([generateSyntheticSymbolRoute(result.symbolId)]);
    }),
  ),
  action$.pipe(
    isTypeOfAndGetPayload(SymbolSyntheticAction.update.done),
    map(({ params }) => {
      return RouterAction.replace([generateSyntheticSymbolRoute(params.symbolId)]);
    }),
  ),
);
